import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import SiteCard from '../SiteCard/SiteCard';
import { FormsCenterContext } from '../../Context/FormsCenterContext';
import { Typography } from '@mui/material';

export default function MyForms() {
  const formsObject = useContext(FormsCenterContext);

  const [filteredSubmittedForms, setFilteredSubmittedForms] = useState([]);
  const [filteredInprogressForms, setFilteredInprogressForms] = useState([]);

  // Logs user out of application
  const logout = async () => {
    // Authenticated via ADFS - Passport SAML
    if (formsObject.isAuthAzureAD) {
      // removes authentication cookie from browser
      await axios.get(`${formsObject.passportURLAzureAD}/logout`, {
        withCredentials: true,
      });

      await formsObject.logout();
    }

    // Authenticated via username/password - Passport Local
    if (formsObject.isAuthLocal) {
      axios
        // removes authentication cookie from browser
        .get(`${formsObject.passportUrlLocal}/logout`, {
          withCredentials: true,
        })
        .then(async (res) => {
          //removes userObject/sets isAuth flag to false - see formsCenterContext
          await formsObject.logout();
          window.location.reload();
        });
    }
  };

  // Used to dynamically set the CSS width property
  let userNameLength = 0;
  if (formsObject.user) userNameLength = formsObject.user.UserName.length;

  //fires when formsObject is set
  useEffect(() => {
    if (formsObject.isAuthAzureAD) {
      setFilteredSubmittedForms(formsObject.submittedFormsEmployee);
      setFilteredInprogressForms(formsObject.inProgressFormsEmployee);
    }

    if (formsObject.isAuthLocal) {
      setFilteredSubmittedForms(formsObject.submittedForms);
      setFilteredInprogressForms(formsObject.inProgressForms);
    }
  }, [formsObject]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: 3,
        }}
      >
        {/* Renders log out link */}
        {/* Show if user IS authenticated */}
        {(formsObject.isAuthAzureAD || formsObject.isAuthLocal) && (
          <Box
            sx={{
              '& .MuiTextField-root': { width: `${userNameLength + 3}ch` },
            }}
            noValidate
            autoComplete='off'
          >
            <TextField
              variant='standard'
              InputProps={{ disableUnderline: true }}
              label={`${formsObject.user && formsObject.user.UserName}`}
              select
            >
              <MenuItem value='Logout' onClick={() => logout()}>
                Logout
              </MenuItem>
            </TextField>
          </Box>
        )}
      </Box>

      <Typography variant='body1' sx={{ marginBottom: 4 }}>
        <b>Note:</b> Not all forms are configured to allow for incremental work nor be
        viewed after submission.
      </Typography>
      {filteredInprogressForms.length !== 0 && (
        <>
          {/* Render In Progress Site Cards */}
          <Typography component='h3' variant='h5' align='center'>
            In Progress
          </Typography>
          <Grid container spacing={3} sx={{ marginTop: 2, marginBottom: 4 }}>
            {filteredInprogressForms.length > 0 ? (
              filteredInprogressForms.map((form, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={12} md={6} lg={4}>
                    <Link
                      to={
                        form.SubmittedForApproval
                          ? `/${form.EndPoint}/?id=${form.FormId}&formDataId=${form.FormDataID}&formState=submittedForApproval`
                          : `/${form.EndPoint}/?id=${form.FormId}&formDataId=${form.FormDataID}&formState=inProgress`
                      }
                      style={{ textDecoration: 'none' }}
                    >
                      <SiteCard
                        department={form.Departments}
                        formName={form.CustomFormName || form.FormName}
                        formDescription={form.FormDescription}
                        isEmployeeForm={form.IsEmployeeForm}
                        lastUpdatedDate={form.LastUpdatedDate}
                        formDataId={form.FormDataID}
                        submittedForApproval={form.SubmittedForApproval}
                      />
                    </Link>
                  </Grid>
                </React.Fragment>
              ))
            ) : (
              // Message if there are no Site Cards to render
              <Grid item xs={12}>
                <Typography variant='body1'>
                  There are currently no <b>In Progress Forms</b> available to view.
                </Typography>
              </Grid>
            )}
          </Grid>
        </>
      )}
      {filteredSubmittedForms.length !== 0 && (
        <>
          {/* Render Submitted Site Cards */}
          <Typography component='h3' variant='h5' align='center'>
            Submitted
          </Typography>
          <Grid container spacing={3} sx={{ marginTop: 2 }}>
            {filteredSubmittedForms.length > 0 ? (
              filteredSubmittedForms.map((form, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={12} md={6} lg={4}>
                    <Link
                      to={`/${form.EndPoint}/?id=${form.FormId}&formDataId=${form.FormDataID}&formState=submitted`}
                      style={{ textDecoration: 'none' }}
                    >
                      <SiteCard
                        department={form.Departments}
                        formName={form.CustomFormName || form.FormName}
                        formDescription={form.FormDescription}
                        isEmployeeForm={form.IsEmployeeForm}
                        lastUpdatedDate={form.LastUpdatedDate}
                        formDataId={form.FormDataID}
                        submitted
                      />
                    </Link>
                  </Grid>
                </React.Fragment>
              ))
            ) : (
              // Message if there are no Site Cards to render
              <Grid item xs={12}>
                <Typography variant='body1'>
                  There are currently no <b>Submitted Forms</b> available to view.
                </Typography>
              </Grid>
            )}
          </Grid>
        </>
      )}
    </>
  );
}
